import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {StateService} from "./state.service";
import {UserRole} from "../models/user";

@Injectable({
  providedIn: 'root'
})
class AdminAuthGuard {

  constructor(private router: Router, private stateService:StateService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if (this.stateService.userRole == UserRole.GAO_Admin) {
      return true;
    } else {
      this.stateService.redirectUrl = state.url;
      this.router.navigate(['/unauthorized'] );
      return false;
    }

  }
}

export const AdminAuthGuardService: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(AdminAuthGuard).canActivate(next, state);
}
